module.exports = __webpack_public_path__ + "img/java.8a06434f.webp";